import * as React from "react";
import { useRef } from "react";
import styles from "./Input.module.scss";
import classnames from "classnames";
import CheckboxIcon from "../../icons/CheckboxIcon";
import lodashIsNil from "lodash/isNil";
import useKeyDownDetector, { KEY_NAME_ENTER } from "rylak-common/src/hooks/useKeyDownDetector.jsx";
import { getBrandInputVariant, isInputVariantDefault } from "~/cores/brandDataCore";

function Input(props) {
    const { appProps, disabled, value, onChange, onEnter, required, type = "text", placeholder, validated, validators, errorText, name, onClick, prefix, ref, ...rest } = props;
    const validationErrorText = errorText || (validators && validators.length && validators.find((v) => !v.validator(value))?.text);
    const invalid = validated && validationErrorText;
    const valueExists = !lodashIsNil(value) && value !== "";

    const localRef = useRef();

    const actualRef = ref || localRef;

    useKeyDownDetector((event) => {
        if (event.key === KEY_NAME_ENTER) {
            if (window.document.activeElement === actualRef.current) {
                onEnter && onEnter(value);
            }
        }
    });

    const inputVariant = getBrandInputVariant(appProps);

    const inputVariantIsDefault = isInputVariantDefault(appProps);

    return (
        <div>
            <div
                className={classnames(
                    styles["input-wrapper"],
                    inputVariant && styles["input-brand-variant-" + inputVariant],
                    invalid && styles["input-wrapper-invalid"],
                    disabled && styles["input-wrapper-disabled"],
                )}
            >
                <input
                    ref={actualRef}
                    onClick={onClick}
                    id={name}
                    name={name}
                    data-has-value={valueExists}
                    disabled={disabled}
                    type={type}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    className={classnames(styles["input"], validators && styles["input-with-checkbox"], !placeholder && styles["no-placeholder"])}
                    {...rest}
                />
                <label htmlFor={name} className={styles["floating-label"]}>
                    {!inputVariantIsDefault && prefix && <span>{prefix}&nbsp;</span>}
                    {placeholder}
                </label>
                {inputVariantIsDefault && <span className={styles["floating-prefix"]}>{prefix}</span>}
                {!validationErrorText && valueExists && validators && (
                    <div className={styles["approved-icon"]}>
                        <CheckboxIcon width={"22px"} />
                    </div>
                )}
            </div>
            {invalid && <div className={styles["error-message"]}>{validationErrorText}</div>}
        </div>
    );
}

export default Input;
